"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
const env_1 = __importDefault(require("../env"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const PREFIX = env_1.default.API_GATEWAY_URL || 'http://api.humcapital.test';
const _fetch = (path, { method, body }) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield fetch(PREFIX + '/backend' + path, {
        method,
        body: body && JSON.stringify(body),
        headers: {
            'Content-Type': (body && 'application/json') || 'text/plain',
            Authorization: `Bearer ${js_cookie_1.default.get('tRM7touMig')}`,
        },
        credentials: 'include',
    }).then((response) => response.json());
    // console.log(method, path, JSON.stringify(data, null, 2));
    return data;
});
exports.client = {
    get: (path) => _fetch(path, { method: 'GET' }),
    del: (path) => _fetch(path, { method: 'DELETE' }),
    post: (path, body) => _fetch(path, { method: 'POST', body }),
    put: (path, body) => _fetch(path, { method: 'put', body }),
    patch: (path, body) => _fetch(path, { method: 'PATCH', body }),
};
//# sourceMappingURL=client2.js.map